import { createApp } from 'vue'
import App from './App.vue'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import './assets/css/main.css';

createApp(App).use(Quasar, quasarUserOptions).mount('#app')
